import { userDetailsStore } from '@/stores/auth/user-details.store';

class PermissionHelper {
  constructor() {
    setTimeout(() => {
      this.userDetailsStore = userDetailsStore();
    });
  }

  checkAuth(role) {
    return this.userDetailsStore?.getUserRoles?.includes(role);
  }

  checkModuleAuth(moduleName) {
    return this.userDetailsStore?.getAccessedModules?.includes(moduleName);
  }
}

export default new PermissionHelper();
